import { render, staticRenderFns } from "./ActionExtraPayment.vue?vue&type=template&id=a4c56a8e"
import script from "./ActionExtraPayment.vue?vue&type=script&lang=js"
export * from "./ActionExtraPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports